import React from "react";
import {
    Box,
    Container,
    Row,
    Column,
    FooterLink,
    Heading, SubHeading, FooterDiv,
} from "./FooterStyles";
import PrivacyPolicy from "./Privicy-policy/PrivacyPolicy";


const Footer = () => {
    return (
        <FooterDiv>
            <Row>
                <Column>
                    <SubHeading>About Us</SubHeading>
                    <FooterLink href="https://www.datamachine.info">Datamachine Website</FooterLink>
                </Column>
                <Column>
                    <SubHeading>Services</SubHeading>
                    <FooterLink href="https://www.datamachine.info#EnumeratedListRight">Knowledge Graph</FooterLink>
                    <FooterLink href="https://www.datamachine.info#EnumeratedListRight">VisualSearch</FooterLink>
                    <FooterLink href="https://www.datamachine.online">Imageviewer Login</FooterLink>
                </Column>
                <Column>
                    <SubHeading>Contact Us</SubHeading>
                    <FooterLink href="https://www.datamachine.info/contact">Address</FooterLink>
                    <FooterLink href="https://www.datamachine.nl/images/18e27a13-536e-458c-9953-17006a2064ea">General Terms and Conditions</FooterLink>
                    <FooterLink href="https://www.datamachine.nl/images/5367ab25-04e3-4102-9ba9-3ec35972408a">Cookie Policy</FooterLink>
                    <FooterLink href="https://www.datamachine.nl/images/8d44e8ba-fc68-4b3d-bd00-a962621d4479">Privacy Policy</FooterLink>
                    <FooterLink href="https://www.datamachine.nl/images/5142ede3-f78f-4033-8d9f-1e75ebaa5fae">Api documentation</FooterLink>
                </Column>
                {/*    <Column>*/}
                {/*        <SubHeading>Social Media</SubHeading>*/}
                {/*        <FooterLink href="#">*/}
                {/*            <i className="fab fa-facebook-f">*/}
                {/*<span style={{ marginLeft: "10px" }}>*/}
                {/*  Facebook*/}
                {/*</span>*/}
                {/*            </i>*/}
                {/*        </FooterLink>*/}
                {/*    </Column>*/}
            </Row>
        </FooterDiv>
    );
};
export default Footer;
